import React from "react";
import { clsx } from "clsx";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import { useTranslateMessage } from "~i18n";

import styles from "./Byline.module.css";

interface BylineProps {
    byline?: string;
    isOpinion?: boolean;
    preText?: string;
}

export default function Byline({
    byline = "",
    isOpinion = false,
    preText,
}: BylineProps) {
    const translateMessage = useTranslateMessage();
    if (!byline?.length) return null;

    return (
        <div
            data-component="byline"
            className={clsx(typographyStyles.articleLabel, {
                [styles.opinion]: isOpinion,
            })}
        >
            {preText ? (
                <span>
                    <span className={styles.preText}>{preText}</span>{" "}
                    <span>{byline}</span>
                </span>
            ) : (
                <span>
                    {translateMessage(
                        { id: "by", defaultMessage: "By {byline}" },
                        { byline }
                    )}
                </span>
            )}
        </div>
    );
}
